import { render, staticRenderFns } from "./commentsList.vue?vue&type=template&id=c8d3291e&"
import script from "./commentsList.vue?vue&type=script&lang=js&"
export * from "./commentsList.vue?vue&type=script&lang=js&"
import style0 from "./commentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports